module.exports = __webpack_public_path__ + "static/media/remi-yuan-JMB3Efb8yoQ-unsplash.dffb944a.jpg";